import { Navigate, useSearchParams } from 'react-router-dom';

/** Ancien chemin /client/search/quote — redirige vers le formulaire devis avec déménageur, ou vers la recherche. */
export default function SearchQuote() {
  const [sp] = useSearchParams();
  const mover = sp.get('mover');
  if (mover) {
    const q = new URLSearchParams({ mover });
    const name = sp.get('name');
    const truck = sp.get('truck');
    if (name) q.set('moverName', name);
    if (truck) q.set('moverTruck', truck);
    return <Navigate to={`/client/devis?${q.toString()}`} replace />;
  }
  return <Navigate to="/client/search" replace />;
}
